import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CommonDtoKeysEnum } from '@zaoblako/shared/common/enums/common-dto-keys.enum';

import * as yup from 'yup';

/** Auto-disableable object common request and response body - DTO signature */
export interface AutoDisableableInterface {
  /** Is object disabled */
  disabled?: boolean;
  /** If date defined, then object will be automatically disabled at this date */
  activeUntil?: Date;
}

/** Auto-disableable object common request and response body - DTO schema */
export const AutoDisableableDto = SerdeDtoClass.create<AutoDisableableInterface>(CommonDtoKeysEnum.AUTO_DISABLEABLE_DTO, {
  disabled: {
    sortable: true,
    optional: true,
    label: 'Объект неактивен',
    serializer: yup.boolean(),
  },
  activeUntil: {
    sortable: true,
    optional: true,
    label: 'Объект активен до',
    serializer: yup.date(),
  },
});
